<template>
    <v-container grid-list-md fluid fill-height>
        <v-layout row wrap>
            <v-flex style="height: calc(100vh - 88px); position: fixed; width: 160px;">
                <v-card height="100%">
                    <v-navigation-drawer :mobile-breakpoint="0" :width="300">
                        <v-list dense>
                            <v-list-item :to="{name: 'departmentsGridFaculty'}"
                                         exact-active-class="list-title-active">
                                <v-list-item-content>
                                    <v-list-item-title>Всі факультети і типи</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            
                            <v-subheader class="mt-4 grey--name name--darken-1">Факультети</v-subheader>
                            <navigation-list-template :items="faculties"/>

                            <v-subheader class="mt-4 grey--name name--darken-1">Тип</v-subheader>
                            <navigation-list-template :items="departmentType"/>
                        </v-list>
                    </v-navigation-drawer>
                </v-card>
            </v-flex>

            <v-flex style="margin-left: 160px; width: calc(100% - 460px);">
                <v-card>
                    <departments-index/>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import HttpService from "../../../../HttpService";
    import DepartmentsIndex from "../../../../components/admin/Dictionaries/Departments/DepartmentsIndex";
    import NavigationListTemplate from "../../../../components/common/NavigationListTemplate";
    import departmentTypes from "../.././../../constants/admin/departmentTypes";

    export default {
        components: {
            DepartmentsIndex,
            NavigationListTemplate
        },
        mounted() {
            HttpService.getInstance()
                .get("faculties/getAll")
                .then(res => {
                    this.faculties = res.map(faculty => {
                        faculty.name = faculty.nameShortUk;
                        faculty.route = {
                            name: 'departmentsGridFaculty',
                            params: {
                                facultyId: faculty.id,
                            }
                        };

                        return faculty;
                    });
                });
        },
        data: () => {
            return {
                faculties: [],
                departmentType: departmentTypes.map(dptTypes => {
                    return {
                       name: dptTypes.nameConst,
                       route: {
                           name: 'departmentsGridDepartment',
                           params: {
                               departmentType: dptTypes.typeEnum,
                           }
                       }
                   };
                }),
            };
        }
    }
</script>